export default "d r=dr\nt r=tr\n";